import {
    Customer, Address, CompetitorPricingLine
} from 'ep-bt-field-agent-proxy';
import { CompetitorPriceLine } from './competitor-price-line.model';
import { CompetitorPriceType } from 'ep-bt-controls';

export class CompetitorPricing {
    constructor() {
        //  this.Lines = new CompetitorPricingLine();
        this.PriceType = CompetitorPriceType.StandardPrice;

    }

    /// <summary>
    /// This is Customer/Competitor
    /// </summary>
    private _customer: Customer;
    public get customer(): Customer {
        return this._customer;
    }
    public set customer(value: Customer) {
        this._customer = value;
    }


    // public customerObj: Customer;
    /// <summary>
    /// List of competitor adresseses
    /// </summary>
    // public IList<Address> Addresses { get; set; }

    public competitorAddress: Address[] = [];

    public get CompetitorID(): number {
        return this.customer.customerId;
    }

    public Lines: CompetitorPriceLine[] = [];

    public nextLineNumber = 1;

    LineAdd(line: CompetitorPriceLine, adding: boolean = true) {
        line.SetLineNumber(this.nextLineNumber++);
        line.Adding = adding;
        this.Lines.push(line);
    }


    LineRemove(lineNumber: number) {
        const orderLine = this.Lines.filter(x => x.lineNumber == lineNumber)[0];
        this.Lines.splice(this.Lines.indexOf(orderLine), 1);
    }
    // public void LineRemove(int lineNumber);
    // {
    //     var orderLine = this.Lines.First(l => l.LineNumber == lineNumber);
    //     this.Lines.Remove(orderLine);
    // }

    /// <summary>
    /// Selected Address
    /// </summary>
    // public Address SelectedAddress { get; set; }


    private _selectedAddress: Address;

    public get SelectedAddress(): Address {
        return this._selectedAddress;
    }

    public set SelectedAddress(value: Address) {
        this._selectedAddress = value;
    }
    /// <summary>
    /// Selected index
    /// </summary>
    // public int SelectedAddressIndex { get; set; }

    private _selectedAddressIndex: number;

    public get SelectedAddressIndex(): number {
        return this._selectedAddressIndex;
    }

    public set SelectedAddressIndex(value: number) {
        this._selectedAddressIndex = value;
    }


    private _selectedLine: CompetitorPriceLine;

    public get SelectedLine(): CompetitorPriceLine {
        return this._selectedLine;
    }

    public set SelectedLine(value: CompetitorPriceLine) {
        this._selectedLine = value;
    }

    /// <summary>
    /// This property will be used for Customer search
    /// </summary>
    private _origin: string;

    public get Origin(): string {
        return this._origin;
    }

    public set Origin(value: string) {
        this._origin = value;
    }


    private _priceType: CompetitorPriceType;

    public get PriceType(): CompetitorPriceType {
        return this._priceType;
    }

    public set PriceType(value: CompetitorPriceType) {
        this._priceType = value;
    }
}
